"use client";

import styles from "@/styles/modules/components/video.module.scss";
import Image from "next/image";
import { useRef, useState } from "react";

interface VideoProps {
  video: string;
  isFullHeight?: boolean;
}

export default function Video({ video, isFullHeight }: VideoProps) {
  const [isPlaying, setIsPlaying] = useState<boolean>(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  const handlePlayPause = () => {
    if (isPlaying) {
      videoRef.current!.pause();
      setIsPlaying(false);
    } else {
      videoRef.current!.play();
      setIsPlaying(true);
    }
  };

  return (
    <div
      className={`${styles.videoContainer} ${
        isFullHeight ? styles.fullHeight : ""
      }`}
    >
      <video muted loop ref={videoRef} className={styles.video}>
        <source src={video} type="video/mp4" />
      </video>
      <span
        className={`${styles.play} ${isPlaying ? styles.playing : ""}`}
        onClick={handlePlayPause}
      >
        {isPlaying ? (
          <Image
            alt="Play icon"
            src="/icons/pause-icon.svg"
            width={66}
            height={77}
          />
        ) : (
          <Image
            alt="Pause icon"
            src="/icons/play-icon.svg"
            width={65}
            height={78}
          />
        )}
      </span>
    </div>
  );
}
